import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { AccordionList, Accordion } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';
import Coordinates from './Coordinates.jsx';
import TimeWindows from './TimeWindows.jsx';
import Times from './Times.jsx';
import Sizes from './Sizes.jsx';
import AccordionTimeWindow from './AccordionTimeWindow.jsx';

function StopDetailsInfoAccordion({
  routeId, stopId, hasSizes, hasTimeWindows, stop, locationId
}) {
  return (
    <AccordionList>
      <Accordion
        label={getResourceTo('Stop.popup.timesBaselineActualExpansionBox')}
      >
        <Times routeId={routeId} stopId={stopId} stop={stop} />
      </Accordion>
      <Accordion
        isVisible={hasSizes}
        label={getResourceTo('Stop.popup.sizesExpansionBox')}
      >
        <Sizes routeId={routeId} stopId={stopId} stop={stop} />
      </Accordion>
      <Accordion
        label={getResourceTo('Stop.popup.coordinatesExpansionBox')}
      >
        <Coordinates routeId={routeId} stopId={stopId} stop={stop} />
      </Accordion>
      <Accordion label={getResourceTo('Stop.popup.tw')}>
        {hasTimeWindows ? (
          <TimeWindows routeId={routeId} stopId={stopId} stop={stop} />
        ) : (
          <AccordionTimeWindow locationId={locationId} />
        )}
      </Accordion>
    </AccordionList>
  );
}

StopDetailsInfoAccordion.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hasSizes: PropTypes.bool.isRequired,
  hasTimeWindows: PropTypes.bool.isRequired,
  stop: PropTypes.object.isRequired
};

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  hasSizes: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop', 'sizes'], Map({})).size > 0,
  hasTimeWindows: stopDetailsPopup.hasIn([String(routeId), String(stopId), 'stop', 'location', 'timeWindows']),
  locationId: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop', 'location', 'id'])
});

export default connect(mapStateToProps, null)(StopDetailsInfoAccordion);
